import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { useSelector } from 'react-redux';
import { Card, CardContent, Grid } from '@mui/material';
import './index.css'
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';

import Timeline from 'react-timelines'
import 'react-timelines/lib/css/style.css'
import { START_YEAR, NUM_OF_YEARS, NUM_OF_TRACKS } from './constants'
import { buildTimebar, buildTrack } from './builders'
import { fill } from './utils'
const now = new Date('2022-12-12')
const timebar = buildTimebar()

// eslint-disable-next-line no-alert
const clickElement = element => {
  console.log("element", element)
  alert(`Clicked element\n${JSON.stringify(element, null, 2)}`)
}

const MIN_ZOOM = 2
const MAX_ZOOM = 20

const Calendario = ({openFullScreenDialog, handleClose, title}) => {

  const tracksById = fill(NUM_OF_TRACKS).reduce((acc, i) => {
    const track = buildTrack(i + 1)
    acc[track.id] = track
    return acc
  }, {})


  const [state, setState] = useState({
    open: false,
    zoom: 2,
    tracksById,
    tracks: Object.values(tracksById),
  })

    const handleToggleOpen = () => {
      setState(({ open }) => ({ open: !open }))
    }

    const handleZoomIn = () => {
      setState(({ zoom }) => ({ zoom: Math.min(zoom + 1, MAX_ZOOM) }))
    }

    const handleZoomOut = () => {
      setState(({ zoom }) => ({ zoom: Math.max(zoom - 1, MIN_ZOOM) }))
    }

    const handleToggleTrackOpen = track => {
      setState(state => {
        const tracksById = {
          ...state.tracksById,
          [track.id]: {
            ...track,
            isOpen: !track.isOpen,
          },
        }

        return {
          tracksById,
          tracks: Object.values(tracksById),
        }
      })
    }

  const { open, zoom, tracks } = state
  const start = new Date(`${START_YEAR}`)
  const end = new Date(`${START_YEAR + NUM_OF_YEARS}`)
  console.log("tracks", tracks)

  return (
    <DialogoPantallaCompleta
      openFullScreenDialog={openFullScreenDialog}
      handleClose={handleClose}
      title={title}
      fullscreen={true}
    >
    <Card>
      <CardContent>
        <Grid container>
            <Grid item xs={12} >
              <div className="app">
                {tracks?.length > 0 && (
                  <Timeline
                    scale={{
                      start,
                      end,
                      zoom,
                      zoomMin: MIN_ZOOM,
                      zoomMax: MAX_ZOOM,
                    }}
                    isOpen={open}
                    toggleOpen={handleToggleOpen}
                    zoomIn={handleZoomIn}
                    zoomOut={handleZoomOut}
                    clickElement={clickElement}
                    clickTrackButton={track => {
                      // eslint-disable-next-line no-alert
                      alert(JSON.stringify(track))
                    }}
                    timebar={timebar}
                    tracks={tracks}
                    now={now}
                    toggleTrackOpen={handleToggleTrackOpen}
                  />
                )}
              </div>
              </Grid>
              <Grid item xs={12}>
                <Sidebar />
              </Grid>
          </Grid>
        </CardContent>
      </Card>
      </DialogoPantallaCompleta>
  );
}

export default Calendario;